<template>
  <div>
    <!-- <div class="field-row">
        <input type="text" v-model="title" name="" id="" placeholder="Category name" />
    </div>
    <div class="field-row">
        <Textarea v-model="description" placeholder="description"></Textarea>
    </div>
    <div class="field-row">
        <button @click.prevent="savedata">Save</button>
    </div> -->
    <a-modal v-model="visible" width="1080px" title="Edit Book Details" onOk="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Edit Book</a-button>
      </template>
      <a-form class="mb-4" :form="form">
        <div class="row">
          <div class="col-md-6">
            <a-form-item label="Title">
              <a-input placeholder="Title"
                v-decorator="['title', { rules: [{ required: true, message: 'Please input book title!' }, { max: 300, message: 'Must not exceed 300 characters!' }] }]" />
            </a-form-item>
            <a-form-item label="Author">
              <a-input placeholder="Author"
                v-decorator="['author', { rules: [{ required: true, message: 'Please input book author!' }, { max: 300, message: 'Must not exceed 300 characters!' }] }]" />
            </a-form-item>
            <a-form-item label="Description">
              <a-textarea placeholder="Description" :autosize="{ minRows: 2 }"
                v-decorator="['description', { rules: [{ max: 100, message: 'Must not exceed 100 characters!' }] }]" />
            </a-form-item>
            <a-form-item label="Remark">
              <a-textarea placeholder="Remark" :autosize="{ minRows: 2 }"
                v-decorator="['remark', { rules: [{ max: 100, message: 'Must not exceed 100 characters!' }] }]" />
            </a-form-item>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6">
                <a-form-item label="Book Code">
                  <a-input placeholder="Book code. eg: CHEM-IX-UNIQUE"
                    v-decorator="['code', { rules: [{ required: true, message: 'Please input book code!' }, { max: 30, message: 'Must not exceed 30 characters!' }] }]" />
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item label="Rack Name/Number">
                  <a-input placeholder="Rack Name/Number"
                    v-decorator="['rack_name', { rules: [{ required: false, message: 'Please input rack name!' }] }]" />
                </a-form-item>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <a-form-item label="Select category">
                  <a-select placeholder="Select category"
                    v-decorator="['category_id', { rules: [{ required: true, message: 'Please select a category!' }] }]"
                    @change="handleCategorySelect">
                    <a-select-option v-for="(cat, index) in categories" :key="index"
                      :value="cat.id">{{ cat.name }}</a-select-option>
                  </a-select>
                </a-form-item>
              </div>
              <div class="col-md-6">
                <a-form-item label="Select sub category">
                  <a-select placeholder="Select sub category"
                    v-decorator="['sub_category_id', { rules: [{ required: false, message: 'Please select a sub category!' }] }]">
                    <a-select-option v-for="(cat, index) in subCategories" :key="index"
                      :value="cat.id">{{ cat.name }}</a-select-option>
                  </a-select>
                </a-form-item>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <a-form-item label="No. of Copies">
                  <a-input-number style="width: 100%" placeholder="No. of Copies"
                    v-decorator="['total_quantity', { rules: [{ required: false, message: 'Please input book quantity!' }] }]" />
                </a-form-item>
              </div>

              <div class="col-md-6">
                <a-form-item label="Class">
                  <a-select
                    v-decorator="['class_id', { rules: [{ required: false, message: 'Please select a class!!' }] }]"
                    placeholder="Select class">
                    >

                    <a-select-option v-for="(sclass, index) in schoolClasses" :value="sclass.id" :key="index">
                      {{ sclass.name }}
                    </a-select-option>

                  </a-select>
                </a-form-item>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <a-form-item label="Issue Copies">
                  <a-input-number style="width: 100%" placeholder="Issued Copies" :disabled="true"
                    v-decorator="['issued_quantity', { rules: [{ required: false, message: 'Please input book quantity!' }] }]" />
                </a-form-item>
              </div>

              <div class="col-md-6">
                <a-form-item label="Available Copies">
                  <a-input-number style="width: 100%" placeholder="Available Copies"
                    v-decorator="['available_quantity', { rules: [{ required: false, message: 'Please input book quantity!' }] }]" />
                </a-form-item>
              </div>
            </div>
          </div>

        </div>
      </a-form>

    </a-modal>
  </div>
</template>

<script>
// import { fetchInventoryData } from '@/components/inventory/common'
export default {
  name: 'EditBook',
  data: function () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      loading: false,
      oldrecord: {},
      newrecord: {},
      allCategories: [], // All categories including sub categories
      categories: [], // Only the main categories i.e. without subcategories
      subCategories: [],
      schoolClasses: [],
    }
  },
  mounted: function () {
    /* let d = fetchInventoryData('category')
    d.then(data => { this.categories = data.data }).catch(err => console.error(err)) */
    this.getParentCategories()
    this.$eventBus.$on('openEditForm', this.showForm)
  },
  methods: {
    getParentCategories: function () {
      this.$http.get('/api/library/category')
        .then(({ data }) => {
          this.allCategories = data.data
          this.categories = this.allCategories.filter((category) => category.parent_id === null)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSubCategories: function (selectedCategoryId) {
      this.subCategories = this.allCategories.filter((category) => category.parent_id === selectedCategoryId)
    },
    handleCategorySelect: function (selectedCategoryId) {
      console.log('selectedCategoryId:: ', selectedCategoryId)
      this.form.setFieldsValue({
        'sub_category_id': undefined,
      })
      this.getSubCategories(selectedCategoryId)
    },
    showForm: function (record) {
      console.log('Record', record)
      this.visible = true
      this.getClasses()
      this.getSubCategories(record.category_id)
      // console.log('passed record', record)
      this.oldrecord = record
      setTimeout(() => {
        this.form.setFieldsValue({
          title: record.title,
          author: record.author,
          description: record.description,
          category_id: record.category_id,
          sub_category_id: record.sub_category_id,
          class_id: record.class_id,
          rack_name: record.rack_name,
          remark: record.remark,
          status: record.status,
          code: record.code,
          total_quantity: record.total_quantity,
          available_quantity: record.balance_quantity,
          issued_quantity: record.issued_quantity,
        })
      }, 50)
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    getClasses: function () {
      this.$http.get('/api/class')
        .then(({ data }) => {
          this.schoolClasses = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleEdit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('old data', this.oldrecord)
          console.log('formdata', values)
          this.$http
            .patch(`/api/library/books/${this.oldrecord.id}`, {
              title: values.title,
              author: values.author,
              description: values.description,
              category_id: values.category_id,
              sub_category_id: values.sub_category_id,
              class_id: values.class_id,
              rack_name: values.rack_name,
              remark: values.remark,
              status: 1,
              code: values.code,
              total_quantity: values.total_quantity,
              balance_quantity: values.available_quantity,
            })
            .then((resp) => {
              if (resp.status === 200) {
                this.loading = false
                this.visible = false
                this.$emit('onEdited')
                this.$notification['success']({
                  message: 'Successfully edited',
                  description: 'Book details edited successfully!',
                })
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data.',
                })
              }
              this.form.resetFields()
            })
            .catch(error => {
              this.$neoNotify.error(error)
            })
        }
      })
      this.loading = false
    },
  },
}
</script>

<style></style>
